<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">
  @if (cellData) {
    <sc-file-download [fileInfo]="cellData"
                      [download$]="downloadFileExpr(rowData)">
    </sc-file-download>
  }
</ng-template>